export const INSTRUMENTATION_KEY =
  '985781d006ea46e8b8c7408e5a408a9b-a7805192-f100-40aa-97c6-eec5cd404199-6973';
